// Campaigns without a persisted order (order is null/undefined) sort after
// ordered ones, keeping their original relative order.
export function sortCampaignsByOrder(campaigns) {
    return [...campaigns].sort((a, b) => {
        const orderA = typeof a.order === 'number' ? a.order : null
        const orderB = typeof b.order === 'number' ? b.order : null
        if (orderA === null && orderB === null) return 0
        if (orderA === null) return 1
        if (orderB === null) return -1
        return orderA - orderB
    })
}
